define('GameDayCore/GDModel/enums/datasources/DefaultDatasources',['require','exports','module','../../transform/DataTransformers','./StorageKeys'],function(require,exports,module) {
	var transformers = require("../../transform/DataTransformers"),
		storageKeyEnums = require("./StorageKeys")

	return {
		// defaults : {
		// 	expires : 10
		// },
		gumbo: {
			namespace:"{gid}",
			domain : "http://statsapi.mlb.com/",
			pathTemplate: "api/v1/game/{pk}",
			transformer: transformers.GumboJsonParser,
			timeout: 30,
			retries: 1,
			env_QA: { 
				domain : "http://qa-statsapi.mlb.com"
			}
		},
		players: {
			namespace:"{gid}",
			urlTemplate: "/gdcross/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/players.xml",
			transformer: transformers.PlayersXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		playercard: {
			namespace:"{gid}",
			urlTemplate: "/gdcross/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/{playertype}s/{id}.xml",
			transformer: transformers.PlayerCardXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		playercardurl: {
			namespace:"{gid}",
			urlTemplate: "http://m.mlb.com/gameday/player/{id}",
			timeout: 30,
			retries: 1,
			env_qa: { urlTemplate: "http://mqa.mlb.com/gameday/player/{id}" },
			env_beta: { urlTemplate: "http://mbeta.mlb.com/gameday/player/{id}" }
		},
		hotcoldzone: {
			namespace:"{gid}",
			urlTemplate: "/gdcross/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/premium/{playertype}s/{id}/{sit}.xml",
			transformer: transformers.HotColdZoneXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		game: {
			storageKey: storageKeyEnums.DATASOURCE_NAME,
			namespace:"{gid}",
			urlTemplate: "/gdcross/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/game.xml",
			transformer: transformers.GameXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		linescore: {
			canUseTfs : true,
			storageKey: storageKeyEnums.DATASOURCE_NAME,
			namespace:"{gid}",
			urlTemplate: "{tfshost}/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/linescore.xml{timecode}",
			transformer: transformers.LinescoreXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		miniscoreboard: {
			storageKey: storageKeyEnums.DATASOURCE_NAME,
			namespace:"{gid}",
			urlTemplate: "/gdcross/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/miniscoreboard.xml",
			transformer: transformers.GameMiniscoreboardXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		play: {
			canUseTfs: true,
			storageKey: storageKeyEnums.DATASOURCE_NAME,
			maxElements:1,
			namespace:"{gid}",
			urlTemplate: "{tfshost}/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/plays.xml{timecode}",
			transform: transformers.PlaysXMLToModelTransformer,
			timeout: 30,
			retries: 3,
			expires: 5
		},
		boxscore: {
			canUseTfs: true,
			storageKey: storageKeyEnums.DATASOURCE_NAME,
			namespace:"{gid}",
			urlTemplate: "{tfshost}/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/boxscore.xml{timecode}",
			transformer: transformers.BoxscoreXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		lineup: {
			canUseTfs: true,
			storageKey: storageKeyEnums.DATASOURCE_NAME,
			namespace:"{gid}",
			urlTemplate: "/gen/lineups/{gdpath}.json",
			transformer: transformers.LinesupJSONToModelTransformer,
			timeout: 60*5,
			retries: 1
		},
		bench: {
			canUseTfs: true,
			storageKey: storageKeyEnums.DATASOURCE_NAME,
			namespace:"{gid}",
			urlTemplate: "{tfshost}/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/bench.xml{timecode}",
			transformer: transformers.BenchFileXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		inning: {
			canUseTfs: true,
			namespace:"{gid}",
			urlTemplate: "{tfshost}/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/inning/inning_{inning}.xml{timecode}",
			transformer: transformers.InningXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		all_innings: {
			canUseTfs: true,
			namespace:"{gid}",
			urlTemplate: "{tfshost}/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/inning/inning_{inning}.xml{timecode}",
			transformer: transformers.AllInningsXMLToModelTransformer,
			timeout: 120,
			retries: 1
		},
		scores: {
			canUseTfs: true,
			namespace:"{gid}",
			urlTemplate: "{tfshost}/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/inning/inning_Scores.xml{timecode}",
			transformer: transformers.ScoringPlaysXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		hitchart: {
			canUseTfs: true,
			namespace:"{gid}",
			urlTemplate: "{tfshost}/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/inning/inning_hit.xml{timecode}",
			transformer: transformers.HitChartXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		gamecenter: {
			maxElements:1,
			namespace:"{gid}",
			urlTemplate: "/gdcross/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/gamecenter.xml",
			transformer: transformers.GamecenterXMLToModelTransformer,
			timeout: 30,
			expires: 30,
			retries: 1,
			env_beta: { urlTemplate: "/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/gamecenter.xml" }
		},
		teamVsPitcher5Y: {
            urlTemplate: "/lookup/named.team_bvp_5y.bam?vs_pitcher_id={pitcher_id}&game_type=%27{game_type:R}%27&team_id={team_id}&year={yyyy}",
            namespace: "{gid}",
            timeout: 30,
            expires: 300,
            transformer: transformers.TeamVsPitcher5YXMLToModelTransformer
        },
        teamLineupHittingStats : {
            urlTemplate: "/lookup/named.mlb_individual_hitting_season_total_repeater.bam?game_type={game_type:R}&season={yyyy}&player_id={playerId}",
            namespace: "{gid}",
            timeout: 30,
            expires: 300,
            transformer: transformers.TeamLineupHittingStatsXMLToModelTransformer
        },
        ticketLinks : {
        	urlTemplate: "/ticketing-client/EventTicket.tiksrv?team_id={team_id}&home_team_id={home_team_id}&site_section={site_section:MOBILE}&ticket_category={ticket_category:TICKETS}&year={year}",
        	namespace: "{gid}",
            timeout: 30,
            expires: 300,
            transformer: transformers.TicketsXMLToModelTransformer
        },
		video: {
			maxElements:1,
			namespace:"{gid}",
            urlTemplate: "/gdcross/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/media/mobile.xml",
            transformer: transformers.HighlightsXMLToModelTransformer,
			timeout: 30,
			retries: 1
		},
		displayconfig: {
			namespace: "app",
			urlTemplate: "/shared/flash/gameday/v5.2/display_config.xml",
			expires:300,
			transformer: transformers.DisplayConfigXMLToModelTransformer
		},
		jingles: {
			namespace: "jingles",
			urlTemplate: "/shared/components/gameday/gdapp/release/shared/json/jingles/{jingle}.swiffy.json",
			expires:300,
			transformer : transformers.JingleJsonValueParser
		},
		skin_config: {
			namespace: "skin_config",
			urlTemplate: "/gameday/v5/skin_config.xml",
			expires:300,
			transformer : transformers.SkinConfigToModelTransformer
		},
		gd_config: {
			namespace: "gd_config",
			urlTemplate: "/gameday/v5/gd_config.xml",
			expires:300,
			transformer : transformers.GdConfigToModelTransformer
		},
		timecode: {
			namespace: "timecode",
			urlTemplate: "/gdcross/components/game/timecode.json",
			expires:300,
			transformer : transformers.DateTimeJSONToModelTransformer
		},
		lookin: {
			namespace: "livelookin",
			urlTemplate: "/gen/multimedia/livelookin.json",//"/GamedayV5/bin-debug/livelookin/livelookin.json"
			expires: 30,
			scenarios: "FLASH_1000K_640X360,FLASH_800K_640X360,FLASH_600K_400X224,FLASH_500K_512X288,FLASH_400K_600X338,FLASH_300K_320X180"
		},
		moundball: {
			namespace: "moundball",
			urlTemplate: "/gen/hb/list/mound-balls.xml",
			expires: 30,
			transformer: transformers.MoundballXMLToModelTransformer
		},
		staticresources: {
			namespace: "staticresources",
			urlTemplate: "/shared/components/gameday/gdapp/release/shared/staticresources.jsp?partner={partner:mlb}",
			expires:300,
			transformer : transformers.StaticResourcesJSONToModelTransformer
		},
        midInningGames: {
            namespace: "midInningGames",
            urlTemplate: "{urlPath}",
            expires:300,
            transformer : transformers.MidInningGameXmlToModelTransformer,
            env_qa: { urlTemplate: "{url:Path}" }
        },
        wrapupArticleList: {
        	namespace: "{gid}",
        	urlTemplate: "/gen/hb/content/mlb/{gamePk}.json",
        	expires: 300,
        	transformer: transformers.WrapupArticleListTransformer
        },
        condensedGame: {
        	maxElements:1,
			namespace:"{gid}",
            urlTemplate: "/gdcross/components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/{gid}/media/mobile.xml",
            transformer: transformers.CondensedGameXMLToModelTransformer,
			timeout: 30,
			retries: 1
        },
        wrapupVideoList: {
        	namespace: "{gid}",
        	urlTemplate: "/gen/multimedia/videolist/game/wrap/{gamePk}.xml",
        	expires: 300,
        	transformer: transformers.WrapupVideoListTransformer
        },
        statcastBatterAverages: {
        	namespace: "{gid}",
        	urlTemplate: "/lookup/json/named.statcast_hit_averages.bam?season={season}&batter_team_id={team_id}",
        	expires: 300,
        	transformer: transformers.StatcastBatterAveragesTransformer
        }
    }
});
